import { ChangeDetectionStrategy, Component, computed, input, InputSignal, Signal } from '@angular/core';
import { IconComponent } from '@libs/components/icons';

@Component({
  selector: 'ui-segmented-progress-bar',
  templateUrl: './segmented-progress-bar.component.html',
  styleUrls: ['./segmented-progress-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconComponent],
})
export class SegmentedProgressBarComponent {
  private readonly currentIndex: Signal<number> = computed(
    (): number => this.steps().indexOf(this.activeStep()),
  );

  public readonly steps: InputSignal<string[]> = input<string[]>([]);
  public readonly activeStep: InputSignal<string> = input<string>('');
  public readonly labels: InputSignal<Record<string, string>> = input<Record<string, string>>({});

  public isCompleted = (stepIndex: number): boolean => stepIndex <= this.currentIndex();
  public label = (step: string): string => this.labels()[step] ?? step;
}
